// src/components/Footer/Footer.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  const handleLinkClick = () => {
    // Scroll to top when navigation link is clicked
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Astrologer Kavitha Nandy</h3>
            <p>Your trusted guide to cosmic wisdom and astrological insights.</p>
          </div>
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li>
                <Link to="/" onClick={handleLinkClick}>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" onClick={handleLinkClick}>
                  About
                </Link>
              </li>
              <li>
                <Link to="/submit-details" onClick={handleLinkClick}>
                  Book Now
                </Link>
              </li>
              <li>
                <Link to="/terms" onClick={handleLinkClick}>
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Contact Us</h3>
            <ul>
              <li>
                <a
                  href="https://wa.me/14252190869?text=Hello%2C%20I%20am%20interested%20in%20an%20astrology%20reading."
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  💬 WhatsApp Us
                </a>
              </li>
              <li>
                <a href="mailto:astrologerkavitha@gmail.com">
                  ✉️ Email Us
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 AstrologybyKavi.com and CosmicKavi.com are properties of A3K LLC. All rights reserved.</p> 
          <p><center>Follow your stars, trust your journey.</center></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;